/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ContractInputs */

const cs_enum_contract = /** @type {(inputs: Enum_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smlouva`)
};

const en_enum_contract = /** @type {(inputs: Enum_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract`)
};

/**
* | output |
* | --- |
* | "Contract" |
*
* @param {Enum_ContractInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_contract = /** @type {((inputs?: Enum_ContractInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ContractInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contract(inputs)
	return cs_enum_contract(inputs)
});